import { useTranslation } from 'next-i18next'

// Internal Components
import Button from '../Button/Button'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const FeedbackModal = () => {
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  return (
    <Button
      label={t('FEEDBACK_MODAL__BTN_FEEDBACK')}
      modal={{ type: 'api', route: 'get/feedback/form' }}
      modifiers={['Button--feedback']}
    />
  )
}

export default FeedbackModal
